import { Box, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import { ReactComponent as AddIcon } from "../../../../assets/card-icons/AddIcon.svg";
import { ReactComponent as RemoveIcon } from "../../../../assets/card-icons/remove.svg";
import Image from "../../../../assets/images/default-img.jpg";
import { useGlobalContext } from "../../../../context/GlobalContext";
import ImageModal from "../../modals/imageModal/ImageModal";
import "./vertical.css";
import { ReactComponent as StockIcon } from "../../../../assets/icons/stock_icons/StockIcon.svg";

const VerticalCard = ({ data, color, onAdd, onRemove, added, allData }) => {
  const [imageModalOpen, setImageModalOpen] = useState({
    isOpen: false,
    imgUrl: null,
    styleNumber: null,
    allData: null,
  });

  const [isAdded, setIsAdded] = useState(false);
  const { cartData } = useGlobalContext();
  const [currentIndex, setCurrentIndex] = useState(
    allData?.findIndex((item) => item?.styleNumber === data?.styleNumber)
  );
  const isFirstItem = currentIndex === 0;
  const isLastItem =
    currentIndex === allData?.length - 1 || allData?.length === 0;

  // Helper function to check if a design is in cart
  const isDesignInCart = React.useCallback(
    (styleNumber) => {
      if (!cartData) return false;

      const normalizedStyleNumber = styleNumber;

      return cartData.some(
        (item) => item?.styleNumber === normalizedStyleNumber
      );
    },
    [cartData]
  );

  const handleClick = (design) => {
    const isCurrentlyAdded = isDesignInCart(design.styleNumber);
    if (!isCurrentlyAdded) {
      onAdd(design);
    } else {
      onRemove(design);
    }
  };

  const handleOpenImageModal = React.useCallback(
    (imgUrl, styleNumber, design) => {
      setCurrentIndex(
        allData?.findIndex((item) => item?.styleNumber === design?.styleNumber)
      );
      setImageModalOpen({
        isOpen: true,
        imgUrl,
        styleNumber,
        allData: design,
      });
    },
    [allData]
  );

  const handleCloseImageModal = React.useCallback(() => {
    setImageModalOpen({ isOpen: false, imgUrl: null, styleNumber: null });
  }, []);

  const handleNextClick = () => {
    if (currentIndex < allData?.length - 1) {
      const newIndex = currentIndex + 1;
      setCurrentIndex(newIndex);
      const nextItem = allData[newIndex];

      setImageModalOpen((prev) => ({
        ...prev,
        imgUrl: nextItem?.imageUrl || null,
        styleNumber: nextItem?.styleNumber,
        allData: nextItem,
      }));
    }
  };

  const handlePrevClick = () => {
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1;
      setCurrentIndex(newIndex);
      const prevItem = allData[newIndex];

      setImageModalOpen((prev) => ({
        ...prev,
        imgUrl: prevItem?.imageUrl || null,
        styleNumber: prevItem?.styleNumber,
        allData: prevItem,
      }));
    }
  };

  return (
    <>
      <div
        style={{
          width: "12vw",
          borderRadius: ".25vw",
          overflow: "hidden",
          background: color,
        }}
      >
        <img
          className="vertical-image"
          style={{ height: "12vw" }}
          src={data?.transformedImageUrl || Image}
          alt={data?.styleNumber}
          onClick={() =>
            handleOpenImageModal(
              data?.imageUrl ? data?.imageUrl : null,
              data?.styleNumber,
              data
            )
          }
        />
        <div
          style={{
            width: "12vw",
            height: "8vh",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: ".5vw",
            gap: ".5vw",
          }}
        >
          <div
            style={{
              // padding: ".5vw",
              color: "#fff",
              display: "flex",
              flexDirection: "column",
              gap: ".5vw",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "baseline" }}>
              <Typography className="card-title">{data?.styleNumber}</Typography>
              {data?.isStock && (
                <IconButton
                  onClick={() => window.open(`/details/${data?.styleNumber}`, "_blank")}
                  sx={{ padding: 0.5, ml: 0.5, pl: 0 }}
                >
                  <StockIcon />
                </IconButton>
              )}
            </Box>
            {/* <div
              style={{ display: "flex", flexDirection: "column", gap: ".3vw" }}
            > */}
            <Typography className="card-subtitle">
              D: {data?.diaWeight} Wt / {data?.diaPcs} Pcs
            </Typography>
            <Typography className="card-subtitle">
              G: {data?.netWeight} N Wt / {data?.grossWeight} Wt
            </Typography>
            {/* </div> */}
          </div>
          <Box
            className="addBtn"
            onClick={() => handleClick(data)}
            style={{ cursor: "pointer" }}
          >
            {added ? <RemoveIcon /> : <AddIcon />}
            <Typography className="addBtnName">
              {added ? "Remove" : "Add to cart"}
            </Typography>
          </Box>
        </div>
      </div>
      <ImageModal
        openModal={imageModalOpen.isOpen}
        handleClose={handleCloseImageModal}
        data={imageModalOpen}
        nextClick={() => handleNextClick()}
        prevClick={() => handlePrevClick()}
        isAdded={isDesignInCart(imageModalOpen.styleNumber)}
        setIsAdded={setIsAdded}
        hasNext={!isLastItem}
        hasPrev={!isFirstItem}
      />
    </>
  );
};

export default React.memo(VerticalCard);
